<template>
	<v-overflow-btn
          :items="presets"
          v-model="select"
          label="Select Date"
          return-object
          single-line
          hide-details
          @change="$emit('input',$event.value)"
          dense
          target="#dropdown-example-1"
        ></v-overflow-btn>
</template>
<script type="text/javascript">
	export default{
		props:['value'],
		data(){
			return {
				select:{ text: 'Today', value:[new Date(),new Date()] },
				presets: [
        { text: 'Today', value:today()},
        { text: 'Yesterday',value:yesterDay()},
        { text: 'This Week', value:thisWeek() },
        { text: 'Last Week', value:lastWeek() }
      ]
			}
		}
	}
  function today(){
    return [new Date(),new Date()];
  }
  function yesterDay(){
    return [new Date(new Date().getDate()-1),new Date(new Date().getDate()-1)];
  }
	function thisWeek(d) {
  d = new Date(d);
  var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
  return [new Date(d.setDate(diff)),new Date()];
}
function lastWeek()
{
   var d = new Date();
        var to = new Date(d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000));
        var from = new Date(d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000));
        return [to,from];
}
</script>